import React, { Component } from 'react';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import ModalComponent from '../ModalComponent/ModalComponent';
import StickyContainer from '../StickyContainer/StickyContainer';
import StickyBody from '../StickyBody/StickyBody';
import StickyFooter from '../StickyFooter/StickyFooter';
import Waypoint from 'react-waypoint';
import './AnnouncementPopup.less';

const LOCALE_PREFIX = 'components/AnnouncementPopup/AnnouncementPopup';

export class AnnouncementPopup extends Component {
    static propTypes = {
        ariaDescribedById: PropTypes.string,
        children: PropTypes.node.isRequired,
        footer: PropTypes.node,
        id: PropTypes.string,
        intl: intlShape.isRequired,
        onClose: PropTypes.func,
        showXButton: PropTypes.bool,
        stickyFooter: PropTypes.bool,
        showPPLogo: PropTypes.bool
    };

    static defaultProps = {
        onHide: () => true,
        showXButton: true,
        stickyFooter: true,
        showPPLogo: true
    };

    constructor() {
        super();

        this.state = {
            fixToBottom: true
        };
    }

    handleWaypointEnter = () => this.setState({ fixToBottom: false });

    handleWaypointLeave = () => this.setState({ fixToBottom: true });

    render() {
        const { ariaDescribedById, children, footer, id, intl, onClose, showXButton, stickyFooter, showPPLogo } = this.props;
        const { fixToBottom } = this.state;
        
        return (
            <ModalComponent
                onClose={onClose}
            >
                <div
                    id={id}
                    className="AnnouncementPopup"
                    role="dialog"
                >
                    <div className="announcement-popup">
                        <StickyContainer>
                            <StickyBody>
                                <div className="announcement-popup-header">
                                    {showXButton && (
                                        <a
                                            data-automation-id="close-popup"
                                            id="close-popup"
                                            className="cue-close-icon pull-right"
                                            href="javascript:void(0)"
                                            onClick={onClose}
                                        >
                                            {intl.formatMessage({ id: `${LOCALE_PREFIX}.close-popup` })}  
                                        </a>
                                    )}
                                    {showPPLogo && (
                                        <div className="ppcredit-logo" role="img" aria-label={intl.formatMessage({ id: `${LOCALE_PREFIX}.ppc-logo` })} />
                                    )}
                                </div>

                                <div className="announcement-popup-content body-content" id={ariaDescribedById}>
                                    {children}
                                    {!stickyFooter && footer}
                                </div>
                            </StickyBody>

                            {stickyFooter && [(
                                <StickyFooter
                                    key="StickyFooter"
                                    fixToBottom={fixToBottom}
                                    fadedBackground={true}
                                >
                                    {footer}
                                </StickyFooter>
                            ), (
                                <Waypoint
                                    key="WayPoint"
                                    onEnter={this.handleWaypointEnter}
                                    onLeave={this.handleWaypointLeave}
                                />
                            )]}
                        </StickyContainer>
                    </div>
                </div>
            </ModalComponent>
        );
    }
}

export default injectIntl(AnnouncementPopup);
